import { Flex } from 'design-system-web';

export default Flex;
